import React from "react";
import { hitHapticFeedback } from "@src/utils";
import { useDispatch, useSelector } from "react-redux";
import { COURSE_TABS_ENUMS } from "@src/utils/constants";
import { TAB_BAR_ENUMS } from "./store/constants";
import { setFreeTrialBottomsheetOpenViaTabSwitch, showFreeTrialBottomSheetAction } from "../../BottomSheets/store/actions";
import { updateWebBackEventStatus } from "../../Tabs/Overview/components/OverviewContent/utility";

function TabBar({ list, active, setTab }) {
  const dispatch = useDispatch()
  const tabList = useSelector(
    (state) => state?.tabBarReducer?.tabList
  ) || [];
  function handleClick(id){
    if(id == TAB_BAR_ENUMS.trialContent){
      const trialTabData = tabList.find((tab) => tab.enumKey === COURSE_TABS_ENUMS.TRIAL_CONTENT);
      if(trialTabData && trialTabData.isLocked) {
        dispatch(setFreeTrialBottomsheetOpenViaTabSwitch(true))
        return dispatch(showFreeTrialBottomSheetAction(true))
      }
    }
    updateWebBackEventStatus(false)
    setTab(id);
  }

  return (
    <div className="TabBar blockSlide">
      <div className="TabBar__List">
        {list?.map((item, index) => (
          <div
            key={item?.id+index}
            className={`TabBar__List--Item ${item?.id === active ? "TabBar__List--Item--active" : "TabBar__List--Item--inActive"}`}
            onClick={() => {
              hitHapticFeedback();
              handleClick(item?.id);
            }}
          >
            {item?.label}
          </div>
        ))}
      </div>
    </div >
  );
}

export default TabBar;
